// src/components/CategoryBreadcrumbs.js
import React, { useState, useEffect } from 'react';
import { Breadcrumbs, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { styled } from '@mui/system';
import PropTypes from 'prop-types';
import { getCategoryPath } from '../services/api';

const CategoryBreadcrumbContainer = styled(Breadcrumbs)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    '& .MuiBreadcrumbs-separator': {
        margin: '0 8px',
    },
}));

const BreadcrumbLink = styled(Typography)(({ theme }) => ({
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
}));

function CategoryBreadcrumbs({ categoryId, onNavigate }) {
    const [categoryPath, setCategoryPath] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        if (categoryId) {
            fetchCategoryPath(categoryId);
        }
    }, [categoryId]);

    const fetchCategoryPath = async (categoryId) => {
        try {
            const response = await getCategoryPath(categoryId);
            setCategoryPath(response.data);
        } catch (err) {
            console.error('Error fetching category path:', err);
            setError('Failed to load category path.');
        }
    };

    if (error) {
        return (
            <Typography color="error" variant="body2">
                {error}
            </Typography>
        );
    }

    if (categoryPath.length === 0) return null;

    return (
        <CategoryBreadcrumbContainer
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="category path"
        >
            {categoryPath.map((cat, index) => (
                <BreadcrumbLink
                    key={cat.id}
                    color={index === categoryPath.length - 1 ? 'text.primary' : 'text.secondary'}
                    onClick={() => {
                        if (onNavigate) {
                            onNavigate(cat.id);
                        }
                    }}
                >
                    {cat.name}
                </BreadcrumbLink>
            ))}
        </CategoryBreadcrumbContainer>
    );
}

CategoryBreadcrumbs.propTypes = {
    categoryId: PropTypes.number.isRequired,
    onNavigate: PropTypes.func, // Optional callback when a breadcrumb is clicked
};

export default CategoryBreadcrumbs;
